export default "__VITE_ASSET__HzUZI5wp__"